import React, { Component } from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import i18n from '../i18n.json'

class AboutLogo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      logoName: this.props.newLogo.userPrefs.logoName,
      brandSlogan: this.props.newLogo.userPrefs.brandSlogan,
      logoDescription: this.props.newLogo.userPrefs.logoDescription
    }
  }

  componentDidMount() {
    if (this.refs.logoInput) {
      // Need a small delay to complete CSSTransitionGroup
      setTimeout(() => { this.refs.logoInput.focus() }, 500)
    }
  }

  handleNameChange(e) {
    let {value} = e.target
    this.setState({
      logoName: value
    })
    this.props.updateLogoName({
      logoName: value
    })
  }

  handleSloganChange(e) {
    let {value} = e.target
    this.setState({
      brandSlogan: value
    })
    this.props.updateSlogan({
      brandSlogan: value
    })
  }

  handleDescriptionChange(e) {
    let {value} = e.target
    this.setState({
      logoDescription: value
    })
    this.props.updateLogoDescription({
      logoDescription: value
    })
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.props.stepSector()
    }
  }

  render() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div className="landing">
        <div id="about-section">

          <div id="about-background">
          <div id="about-cover" />

          </div>
          </div>

          <div id="about-box">

            <div className="website-button-wrapper">
              <a href="/pricing">
               <FontAwesomeIcon icon={["fa", "angle-double-right"]} /> { i18n[selectedLanguage]['step-about-new'] }
              </a>
            </div>
           <h1>{ i18n[selectedLanguage]['step-about-title'] }</h1>
           <p>{ i18n[selectedLanguage]['step-about-subtitle'] }</p>
           <input
             ref="logoInput"
             name="logoName"
             value={this.state.logoName}
             onKeyPress={this.handleKeyPress.bind(this)}
             onChange={this.handleNameChange.bind(this)}
             type="text"
             className="form-control"
             placeholder={ i18n[selectedLanguage]['step-about-placeholder-brandname'] }
             aria-describedby="sizing-addon1" />
           {/*<div id="sloganInput"></div>*/}
           <input
             ref="sloganInput"
             name="brandSlogan"
             value={this.state.brandSlogan}
             onKeyPress={this.handleKeyPress.bind(this)}
             onChange={this.handleSloganChange.bind(this)}
             type="text"
             className="form-control"
             placeholder={ i18n[selectedLanguage]['step-about-placeholder-slogan'] }
             aria-describedby="sizing-addon1" />

          </div>
       <div className="landing-section">
         <h1 style={{ textAlign: "center" }}>{ i18n[selectedLanguage]['landing-need-title'] }</h1> <br/>
        {/*  <p style={{ textAlign: "center"}}>{ i18n[selectedLanguage]['landing-need-p1'] }</p> */}

         <div className="row">
            <div className="col-4">
              <ul className="about-list">
                 <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item1'] }</li>
                 <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item2']}</li>
                 <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item3']}</li>
                 <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item4']}</li>
              </ul>
            </div>

            <div className="col-4">
              <ul className="about-list">
                <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item5']}</li>
                <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item6']}</li>
                <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item7']}</li>
                <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item8']}</li>
              </ul>
           </div>

           <div className="col-4">
             <ul className="about-list">
               <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item9']}</li>
               <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item10']}</li>
               <li><FontAwesomeIcon icon={["fa", "check"]} className="check-icons" /> { i18n[selectedLanguage]['pricing-item11']}</li>
             </ul>
           </div>
         </div>
       </div>

    <div className="landing-section">

      <div className="flex-row">
        <div className="col-6">
          <div className="landing-box">
            <h2>{ i18n[selectedLanguage]['landing-easy-subtitle'] }</h2>
            <h1>{ i18n[selectedLanguage]['landing-easy-title'] }</h1>
            <p>{ i18n[selectedLanguage]['landing-easy-p1'] }</p>
            <p>{ i18n[selectedLanguage]['landing-easy-p2'] }</p>
          </div>
        </div>
        <div className="col-6">
          <img src="/landing_page/macbook_white.jpg" alt="Easy. Fast. Accessible." />
        </div>
      </div>

    </div>

    <div className="landing-section">

      <div className="flex-row">
        <div className="col-6">
          <img src="/landing_page/just_starting.jpg" alt="We're just starting" />
        </div>
        <div className="col-6">
          <div className="landing-box">
            <h2>{ i18n[selectedLanguage]['landing-preview-subtitle'] }</h2>
            <h1>{ i18n[selectedLanguage]['landing-preview-title'] }</h1>
            <p>{ i18n[selectedLanguage]['landing-preview-p1'] }</p>
          </div>
        </div>
      </div>

    </div>

    <div className="landing-section landing-section-dark">

      <div className="flex-row">

        <div className="col-6">
          <img src="/landing_page/generative.jpg" alt="We use Generative Design" />
        </div>

        <div className="col-6">
          <div className="landing-box">
            <h2>{ i18n[selectedLanguage]['landing-generative-subtitle'] }</h2>
            <h1>{ i18n[selectedLanguage]['landing-generative-title'] }</h1>
            <p>{ i18n[selectedLanguage]['landing-generative-p1'] }</p>
            <p>{ i18n[selectedLanguage]['landing-generative-p2'] }</p>
          </div>
        </div>

      </div>

    </div>


    <div className="landing-section landing-section-dark">

      <div className="flex-row">

        <div className="col-6">
          <div className="landing-box">
            <h2>{ i18n[selectedLanguage]['landing-augment-subtitle'] }</h2>
            <h1>{ i18n[selectedLanguage]['landing-augment-title'] }</h1>
            <p>{ i18n[selectedLanguage]['landing-augment-p1'] }</p>
            <p>{ i18n[selectedLanguage]['landing-augment-p2'] }</p>
          </div>
        </div>

        <div className="col-6" style={{ padding: 0 }}>
          <img src="/landing_page/space.jpg" style={{ marginBottom: "10%" }} alt="Amplify your creativity with AI" />
        </div>

      </div>

    </div>

    <div className="landing-section">

      <div className="flex-row">

        <div className="col-6">
          <img src="/landing_page/guideline_white.jpg" alt="Only one source of truth" />
        </div>

        <div className="col-6">
          <div className="landing-box">
            <h2>{ i18n[selectedLanguage]['landing-truth-subtitle'] }</h2>
            <h1>{ i18n[selectedLanguage]['landing-truth-title'] }</h1>
            <p>{ i18n[selectedLanguage]['landing-truth-p1'] }</p>
            <p>{ i18n[selectedLanguage]['landing-truth-p2'] }</p>
          </div>
        </div>

      </div>

    </div>

    <div className="landing-section landing-section-dark">

      <div className="flex-row">

        <div className="col-6" style={{ padding: 0 }}>
          <img src="/landing_page/hands.jpg" alt="One plan only" />
        </div>

        <div className="col-6">
          <div className="landing-box">
            <h2>{ i18n[selectedLanguage]['landing-plan-subtitle'] }</h2>
            <h1>{ i18n[selectedLanguage]['landing-plan-title'] }</h1>
            <p>{ i18n[selectedLanguage]['landing-plan-p1'] }</p>
            <p>{ i18n[selectedLanguage]['landing-plan-p2'] }</p>
          </div>
        </div>

      </div>

    </div>

    <div className="landing-section">

      <div className="flex-row">

        <div className="col-6">
          <img src="/landing_page/ipads.jpg" alt="We're always evolving" />
        </div>

        <div className="col-6">
          <div className="landing-box">
            <h2>{ i18n[selectedLanguage]['landing-evolving-subtitle'] }</h2>
            <h1>{ i18n[selectedLanguage]['landing-evolving-title'] }</h1>
            <p>{ i18n[selectedLanguage]['landing-evolving-p1'] }</p>
            <p>{ i18n[selectedLanguage]['landing-evolving-p2'] }</p>
          </div>
        </div>

      </div>

    </div>

    <div className="landing-section landing-section-dark">

      <div className="flex-row">

        <div className="col-6">
          <div className="landing-box">
            <h2>{ i18n[selectedLanguage]['landing-learning-subtitle'] }</h2>
            <h1>{ i18n[selectedLanguage]['landing-learning-title'] }</h1>
            <p>{ i18n[selectedLanguage]['landing-learning-p1'] }</p>
            <p>{ i18n[selectedLanguage]['landing-learning-p2'] }</p>
            <p>{ i18n[selectedLanguage]['landing-learning-p3'] }</p>
          </div>
        </div>

        <div className="col-6" style={{ padding: 0 }}>
          <img src="/landing_page/learning.jpg" style={{ marginTop: "10%" }} alt="We keep evolving" />
        </div>

      </div>

    </div>

    <div className="landing-section">

      <div className="flex-row">

        <div className="col-6">
          <img src="/landing_page/products.jpg" alt="Experiment in real mockups"/>
        </div>

        <div className="col-6">
          <div className="landing-box">
            <h2>{ i18n[selectedLanguage]['landing-starting-subtitle'] }</h2>
            <h1>{ i18n[selectedLanguage]['landing-starting-title'] }</h1>
            <p>{ i18n[selectedLanguage]['landing-starting-p1'] }</p>
            <p>{ i18n[selectedLanguage]['landing-starting-p2'] }</p>
            <p>{ i18n[selectedLanguage]['landing-starting-p3'] }</p>
          </div>
        </div>

      </div>

    </div>

    <div id="bottom-section" className="landing-section">

        <div className="flex-row">

          <div className="col-2">
            <ul className="bottom-list">
              <h2>{ i18n[selectedLanguage]['company'] }</h2>
              <li><a href="/about">{ i18n[selectedLanguage]['bottom-about'] }</a></li>
              <li><a href="/pricing">{ i18n[selectedLanguage]['bottom-pricing'] }</a></li>
              <li><a href="/tos"> { i18n[selectedLanguage]['bottom-tos'] }</a></li>
              <li><a href="/privacy"> { i18n[selectedLanguage]['bottom-privacy'] }</a></li>
              <li><a href="mailto:contact@automagic.design"> { i18n[selectedLanguage]['bottom-contact'] }</a></li>
            </ul>
          </div>

          <div className="col-2">
            <ul className="bottom-list">
              <h2>{ i18n[selectedLanguage]['follow-us'] }</h2>
              <li><a href="https://blog.automagic.design">Blog</a></li>
              <li><a href="https://facebook.com/automagicdesign">Facebook</a></li>
              <li><a href="https://twitter.com/aut0magicdesign">Twitter</a></li>
              <li><a href="https://instagram.com/automagicdesign">Instagram</a></li>
            </ul>
          </div>

          <div className="col-2">
            <p><img src="https://www.paypalobjects.com/webstatic/mktg/logo/bdg_secured_by_pp_2line.png" alt="Secured by PayPal" /></p>
            <p><img src="https://www.paypalobjects.com/webstatic/mktg/logo/AM_SbyPP_mc_vs_dc_ae.jpg" alt="PayPal Acceptance Mark" /></p>
          </div>

          <div className="col-6">
            <p className="made-with-love">
              { i18n[selectedLanguage]['made-with'] } <FontAwesomeIcon icon={["fa", "heart"]} /> { i18n[selectedLanguage]['by'] } <a href="http://cod.ai">cod.ai</a>
            </p>
          </div>

        </div>

    </div>

</div>
    )
  }
}

export default AboutLogo



// WEBPACK FOOTER //
// ./src/components/AboutLogo.js